import config from "@/config";
import type { UrlValidation } from "@/util/urlField";
import { requests } from ".";

const LOCATION_SERVER_URL = config?.LOCATION_SERVER_URL;

interface CreateCustomField {
  name: string;
  fieldKey?: string;
  dataType?: string;
  optionDisplayType?: string;
  allowCustomOption?: boolean;
  picklistOptionsImage?: Array<{
    label: string;
    src: string;
    thumbnailUrl?: string;
    createdAt?: string;
  }>;
  documentType: string;
  showInForms?: boolean;
  model: string;
  parentId?: string;
  description?: string;
  urlValidation?: UrlValidation;
}

export const LocationService = {
  getCustomFields: (
    locationId: string,
    parentId: string,
    skip = 0,
    limit = 10,
    documentType = "field",
    query = "",
    includeStandards = true,
    model = "all"
  ) =>
    requests(LOCATION_SERVER_URL).get(
      `/locations/${locationId}/customFields/search?parentId=${parentId}&skip=${skip}&limit=${limit}&documentType=${documentType}&query=${query}&includeStandards=${includeStandards}&model=${model}`
    ),
  getCustomValues: (locationId: string) =>
    requests(LOCATION_SERVER_URL).get(`/locations/${locationId}/customValues`),
  createCustomField: (locationId: string, params: CreateCustomField) =>
    requests(LOCATION_SERVER_URL).post(`/locations/${locationId}/customFields/`, params),
  updateCustomField: (locationId: string, id: string, params: CreateCustomField) =>
    requests(LOCATION_SERVER_URL).put(`/locations/${locationId}/customFields/${id}`, params),
  getCustomObjects: (locationId: string) => requests().get(`/objects/?locationId=${locationId}`),
};
